export function servicesBoxToggle() {
  document.addEventListener('DOMContentLoaded', () => {
    const cards = document.querySelectorAll('.service-card');

    const closeAll = () => {
      cards.forEach(c => c.classList.remove('is-open'));
    };

    cards.forEach(card => {
      const toggle = card.querySelector('.service-card__toggle');

      if (toggle) {
        toggle.addEventListener('click', (e) => {
          e.stopPropagation();
          // chiudi tutte le altre
          cards.forEach(c => { if (c !== card) c.classList.remove('is-open'); });
          card.classList.toggle('is-open');
        });
      }

  // tap su tutta la card in mobile
  card.addEventListener('click', (e) => {
    if (window.matchMedia('(max-width: 767.98px)').matches) {
      card.classList.toggle('is-open');
    }
  });
    });

    // chiudi se clicchi fuori
    document.addEventListener('click', (e) => {
      if (!e.target.closest('.service-card')) {
        closeAll();
      }
    });

    // chiudi su ESC o resize
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeAll(); });
    window.addEventListener('resize', closeAll);
  });
}